define('getResults',['ajaxHelper', 'configResultsCounts'], (ajaxHelper, configResultsCounts) => {
  'use strict';

  const partnerUrl = document.querySelector('.brand-logo, #nhs_HeaderLogo').href;
  let defaultAjaxUrl;
  let globalCallback;

  /**
   * @private
   * handleSuccessEvent: callback to be executed after a request was success.
   *
   * @param {object} value that is returned from the request made.
   */
  function handleSuccessEvent(value) {
    if (typeof globalCallback !== 'function') {
      return;
    }

    const data = {
      subscribers: ['resultsReady', 'resultsHandling', 'resultsLoaded'],
      response: value
    };

    globalCallback(data);
  }

  /**
   * Gets the market search url for the current location.
   * If there's no market breadcrumb url and location is not synthetic, returns the current url.
   * @returns {string} The market url.
   */
  function getMarketUrl(parameters) {
    const marketBreadCrumbElement = document.querySelector('[data-breadcrumb-area]');
    let marketUrl = '';

    if (marketBreadCrumbElement) {
      marketUrl = marketBreadCrumbElement.href;
    } else if (!parameters.IsMultiLocationSearch) {
      marketUrl = window.location.href;
    }

    return marketUrl;
  }

  /**
   * @public
   * getResults: method to get the results from API.
   *
   * @param {object} parameters from search params object.
   * @param {function} callback to be executed after a response end.
   */
  function getResults(parameters, callback) {
    globalCallback = callback;
    const ajaxUrl = defaultAjaxUrl;
    ajaxHelper.postRequest(
      ajaxUrl,
      {
        async: true,
        data: {
          currentSearchParams: parameters,
          marketUrl: getMarketUrl(parameters)
        },
        abort: true,
        requestHeaders: [
          {
            name: 'Content-Type',
            value: 'application/json'
          }
        ],
        success: handleSuccessEvent
      }
    );
  }

  defaultAjaxUrl = partnerUrl + configResultsCounts.getUrls().routeResults;

  return {
    get: getResults
  };
});

